import React, { useContext } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { RESOURCE_NAME } from "common/authorization";
import { FEATURE_FLAG_NAME } from "common/constants";
import { buildLink } from "common/routing";
import { AuthContext } from "../Authorization/AuthContext";
import { CurrentAdmin } from "../Authorization/types";
import { InsufficientPermissions } from "../Common/InsufficientPermissions";
import { Title } from "../Common/Typography";
import {
  Container,
  Header,
  PermissionsWrapper,
  TabLink,
  TabNav,
  Wrapper,
} from "./__styles__/Settings";
import { Account } from "./Account";
import { Data } from "./Data";
import UserSettings from "./User";
import { Users } from "./Users";

const InsufficientPermissionsWrapper = () => {
  return (
    <PermissionsWrapper>
      <InsufficientPermissions />
    </PermissionsWrapper>
  );
};

const userTabs = ({
  canViewUsersTab,
  canViewDataTab,
  admin,
}: {
  canViewUsersTab: boolean;
  canViewDataTab: boolean;
  admin: Maybe<CurrentAdmin>;
}) => {
  const tabs: Array<{ name: string; path: string }> = [];

  if (!admin) {
    tabs.push({ name: "My profile", path: "/settings/user" });
  }

  tabs.push({ name: "Account", path: "/settings/account" });

  if (canViewDataTab) {
    tabs.push({
      name: "Data",
      path: "/settings/data",
    });
  }

  if (canViewUsersTab) {
    tabs.push({
      name: "Users",
      path: buildLink("usersSettings"),
    });
  }

  return tabs;
};

export default () => {
  const { admin, authorized, isFeatureEnabled } = useContext(AuthContext);
  const canViewTeamSettings = authorized({
    resource: RESOURCE_NAME.USER,
    permission: "list",
  });
  const canViewDataTab = authorized({
    resource: RESOURCE_NAME.DATA_SETTINGS,
    permission: "view",
  });
  const canViewPublicUsers =
    authorized({
      resource: RESOURCE_NAME.PUBLIC_USER,
      permission: "list",
    }) && isFeatureEnabled(FEATURE_FLAG_NAME.PUBLIC_USERS);

  const canViewUsersTab = canViewTeamSettings || canViewPublicUsers;

  const tabs = userTabs({
    canViewDataTab,
    canViewUsersTab,
    admin,
  });

  return (
    <Wrapper>
      <Header>
        <Container>
          <Title size="large" type="regular" style={{ marginBottom: "32px" }}>
            Settings
          </Title>
          {!!tabs && (
            <TabNav>
              {tabs.map(tab => (
                <TabLink
                  to={{ pathname: tab.path, state: { scrollToTop: false } }}
                  key={tab.path}
                >
                  {tab.name}
                </TabLink>
              ))}
            </TabNav>
          )}
        </Container>
      </Header>
      <Container>
        <Switch>
          {!admin && <Route path="/settings/user" component={UserSettings} />}
          <Route path="/settings/account" component={Account} />
          <Route
            path="/settings/data"
            component={canViewDataTab ? Data : InsufficientPermissionsWrapper}
          />
          <Route
            path={buildLink("usersSettings")}
            component={canViewUsersTab ? Users : InsufficientPermissionsWrapper}
          />
          <Redirect to={admin ? "/settings/account" : "/settings/user"} />
        </Switch>
      </Container>
    </Wrapper>
  );
};
